import { type GoalOverview, GoalOverviewType } from "Infrastructure/ApiZfp/Schema";

export const getGoalTargetAmount = (goal: GoalOverview): number | null => {
  switch (goal.type) {
    case GoalOverviewType.other:
      return goal.amount?.value ?? goal.targetAmount?.value ?? null;
    case GoalOverviewType.financial_reserve:
    case GoalOverviewType.vehicle:
    case GoalOverviewType.children: {
      return goal.amount?.value ?? null;
    }
    case GoalOverviewType.housing: {
      return goal.targetSavingsAmount?.value ?? goal.amount?.value ?? null;
    }
    case GoalOverviewType.pension: {
      return goal.targetAmount?.value ?? null;
    }
    default:
      return null;
  }
};
